import React from 'react';
import { Box, Typography } from '@mui/material';
import Layout from '../components/Layout';

const OwnersView: React.FC = () => {
    return (
        <Layout title="Owners">
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    padding: 4,
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        color: '#6B7280',
                        textAlign: 'center',
                    }}
                >
                    Owners page coming soon...
                </Typography>
            </Box>
        </Layout>
    );
};

export default OwnersView; 